<div class="step-container" *transloco="let t">
	@if (deviceClaimingService.claimOpInProgress$ | async) {
		<prism-progress-indicator id="sh-claimng-dialog-progress-bar-discovery" />
	}

	<ng-container
		*ngIf="claimOpInProgress$ | async; then claimingInProgress; else claimingNotInProgress"
	></ng-container>

	<ng-template #claimingInProgress>
		<ng-container>
			<p
				id="sh-add-devices-in-progress-count"
				[ngStyle]="{ visibility: currentClaimProgress.stats.inProgress === 0 ? 'hidden' : 'visible' }"
			>
				{{
					t('cloud.add-devices-dialog.adding-n-of-m-devices', {
						n: currentClaimProgress.stats.inProgress,
						m: currentClaimProgress.stats.totalToDo
					})
				}}
			</p>
		</ng-container>
	</ng-template>

	<ng-template #claimingNotInProgress>
		<p id="sh-add-devices-success-count">
			{{ t('cloud.add-devices-dialog.added-m-devices', { m: currentClaimProgress.stats.success }) }}.
			<span id="sh-add-devices-failure-count" *ngIf="currentClaimProgress.stats.failed > 0">
				&nbsp;{{ t('cloud.add-devices-dialog.add-device-failures', { m: currentClaimProgress.stats.failed }) }}
				<a href="https://service.shure.com/s/contact-us">{{ t('cloud.add-devices-dialog.contact-shure') }}</a>
				{{ t('cloud.add-devices-dialog.for-more-information') }}
			</span>
		</p>
	</ng-template>

	<ng-container class="tables-container">
		<div
			class="local-network-table-container"
			*ngIf="deviceClaimMethod === 'ClaimByTokenOnLocalNetwork'; else DisplayMacSerialTable"
		>
			<sh-local-network-confirmation-table
				id="sh-devices-local-network-confirmation-table"
				class="sh-local-network-confirmation-table"
				[devices]="localNetworkDevicesToClaim"
			>
			</sh-local-network-confirmation-table>
		</div>
		<ng-template #DisplayMacSerialTable>
			<sh-mac-serial-confirmation-table
				id="sh-devices-mac-serial-confirmation-table"
				class="sh-mac-serial-confirmation-table"
				[devices]="macSerialDevicesToClaim"
			>
			</sh-mac-serial-confirmation-table>
		</ng-template>
	</ng-container>
</div>
